import React from "react";

import comptia from "../../assests/tech/comptia.jpg";
import ccnalogo from "../../assests/tech/ccnalogo.jpg";
import Cehlogo from "../../assests/tech/Cehlogo.jpg";
import chfilogo from "../../assests/tech/chfilogo.jpg";
import bughunting from "../../assests/tech/bughunting.jpg";
import pentesting from "../../assests/tech/pentesting.jpg";
import { useNavigate } from "react-router-dom"; 
const InduCourse = () => {
  const navigate = useNavigate(); // Initialize the navigate function

  const handleJoinClick = () => {
    navigate("/CourseEnroll"); // Navigate to the CourseEnroll page
  };
  return (
    <div className="indoCourseContainer">
      <header className="indoCourseHeader">
        <h1>Our Courses</h1>
        <p>Learn industry-ready skills and boost your career in IT & Cybersecurity</p>
      </header>

      <section className="indoCourseGrid">
        {/* CCNA */}
        <div className="indoCourseCard">
          <img src={comptia} alt="COMPTIA A+" />
          <h2>Comptia A+</h2>
          <p>CompTIA A+ is a globally recognized certification for entry-level IT professionals.</p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>

        {/* CEH */}
        <div className="indoCourseCard">
          <img src={ccnalogo} alt="CCNA" />
          <h2>CCNA</h2>
          <p>
            Build a strong foundation in networking and routing protocols with hands-on labs.
          </p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>

        {/* Forensic Science */}
        <div className="indoCourseCard">
          <img src={Cehlogo} alt="CEH" />
          <h2>CEH</h2>
          <p>Learn ethical hacking, penetration testing, and cybersecurity defense techniques.
            Master cybersecurity fundamentals, risk management, and industry-standard security protocols
           </p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>

        {/* CompTIA Security+ */}
        <div className="indoCourseCard">
          <img src={chfilogo} alt="Digital Forensic Investigation" />
          <h2>Digital Forensic Investigation</h2>
          <p> Analyze digital and physical evidence to support criminal investigations and justice.
            .</p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>
         <div className="indoCourseCard">
          <img src={bughunting} alt="Bug Hunting" />
          <h2>Bug Hunting</h2>
          <p>Bug hunting is the process of finding and reporting security vulnerabilities in software, websites, or systems to help improve their safety and performance.</p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>
         <div className="indoCourseCard">
          <img src={pentesting} alt="Pentesting" />
          <h2>Pentesting</h2>
          <p>Penetration testing is the authorized process of simulating cyberattacks on a system to identify and fix security weaknesses before real attackers exploit them.</p>
          <button className="indoEnrollButton" onClick={handleJoinClick}>Enroll Now</button>
        </div>
      </section>
    </div>
  );
};

export default InduCourse;
